import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './RecruiterTermsModal.css';

const RecruiterTermsModal = ({ isOpen, onClose, onAccept }) => {
  const [mounted, setMounted] = useState(false);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen || !mounted) return null;

  const handleAccept = () => {
    if (accepted) {
      onAccept();
    }
  };

  const modalContent = (
    <div className="recruiter-terms-modal-overlay" onClick={onClose}>
      <div className="recruiter-terms-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Terms of Usage for Job Posting</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="modal-body">
          <div className="terms-content">
            <p>By switching to Recruiter Mode, you agree to the following terms:</p>
            
            <div className="terms-list">
              <div className="term-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22,4 12,14.01 9,11.01"></polyline>
                </svg>
                <span>You will post accurate and legitimate job opportunities</span>
              </div>
              <div className="term-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22,4 12,14.01 9,11.01"></polyline>
                </svg>
                <span>You will respond to candidates in a timely and professional manner</span>
              </div>
              <div className="term-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22,4 12,14.01 9,11.01"></polyline>
                </svg>
                <span>You will not post discriminatory or illegal job postings</span>
              </div>
              <div className="term-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22,4 12,14.01 9,11.01"></polyline>
                </svg>
                <span>You will maintain the confidentiality of candidate information</span>
              </div>
              <div className="term-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22,4 12,14.01 9,11.01"></polyline>
                </svg>
                <span>You understand that violations may result in account suspension</span>
              </div>
            </div>

            <div className="terms-checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={accepted}
                  onChange={(e) => setAccepted(e.target.checked)}
                />
                <span>I have read and agree to the terms of usage for job posting</span>
              </label>
            </div>
          </div>
        </div>

        <div className="recruiter-terms-modal-actions">
          <button
            type="button"
            className="recruiter-terms-btn-submit"
            onClick={handleAccept}
            disabled={!accepted}
          >
            Accept & Continue
          </button>
          <button
            type="button"
            className="recruiter-terms-btn-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default RecruiterTermsModal;

